import { MdDelete, MdKeyboardArrowDown } from "react-icons/md";
import { useContext, useRef, useState, useEffect } from "react";
import { AccountContext } from "../contexts/AccountContexts";
import { CiEdit } from "react-icons/ci";
import { loadingActive } from "./Background";
import { AvatarBubble } from "./DeveloperComponents";
import { requestChangeProfilePicture, requestDeleteProfilePicture } from "../requests/profile_requests";
import { setImageUrl } from "../utils";
import { useNavigate } from "react-router-dom";
import { NotificationContext } from "../contexts/NotificationContexts";
import { ContentContext } from "../contexts/ContentContext";
import { useTranslation } from "react-i18next";
import { darkAndLightThemeDefault } from "./ThemeComponents";


export function ProfileSmall() {
    const { t } = useTranslation(['common', 'settings'])
    const { user, onLogout } = useContext(AccountContext);
    const { setIsSidebar } = useContext(NotificationContext)
    const dropdownRef = useRef(null);
    const [optionsShow, setOptionsShow] = useState(false)
    const navigator = useNavigate()


    const handleClick = (e) => {
        e.preventDefault()
        setOptionsShow(!optionsShow)
    }

    const handleLogout = () => {
        onLogout()
    }

    const handleGoToProfile = (e) => {
        e.preventDefault()
        navigator("/admin/settings/profile-settings")
        setIsSidebar(true)
        setOptionsShow(false)
    }

    const handleGoToPreferences = (e) => {
        e.preventDefault()
        navigator("/admin/settings/preference-settings")
        setIsSidebar(true)
        setOptionsShow(false)
    }

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOptionsShow(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <div className="relative z-50" ref={dropdownRef}>

            <button className={`flex relative items-center justify-between p-1 px-2 gap-2 btn border rounded-lg  w-52 cursor-pointer ${darkAndLightThemeDefault}`} onClick={handleClick}>
                <div className="flex gap-2 items-center">

                    <AvatarBubble dev={user} />

                    <h1>{user.name}</h1>
                </div>
                <div className="absolute ltr:right-1 rtl:left-1">
                    <MdKeyboardArrowDown />
                </div>
            </button>
            <div className="absolute top-full flex flex-col gap-1 w-52">
                {
                    optionsShow &&
                    <div className="menu m-0 p-0 mt-[1px]">
                        <span className="flex items-center justify-center flex-nowrap rounded-t-md gap-2 pb-[2px] h-8  w-52 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-600"
                        >
                            <h1 className="">{user.email}</h1>
                        </span>

                        <button onClick={handleGoToProfile} className="btn btn-sm h-10 bg-white border-none dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-none">{t('Profile')}</button>
                        <button onClick={handleGoToPreferences} className="btn btn-sm h-10 bg-white border-none dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-none">{t('Preferences', {ns: 'settings'})}</button>

                        <button onClick={handleLogout} className="btn btn-error border-none dark:bg-red-800 dark:text-gray-300 dark:hover:bg-red-700 rounded-b-lg rounded-t-none">{t('Logout')}</button>
                    </div>
                }
            </div>
        </div>
    )
}


export function MemberProfileSmall() {
    const { t } = useTranslation(['common', 'settings'])
    const { user, onLogout } = useContext(AccountContext);
    const { setIsSidebar } = useContext(NotificationContext)
    const dropdownRef = useRef(null);
    const [optionsShow, setOptionsShow] = useState(false)
    const navigator = useNavigate()


    const handleClick = (e) => {
        e.preventDefault()
        setOptionsShow(!optionsShow)
    }

    const handleLogout = () => {
        // onLogout()
        
    }

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOptionsShow(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <div className="relative z-50" ref={dropdownRef}>

            <button className={`flex btn relative items-center justify-center sm:justify-between p-0 min-h-0 max-h-max border-none sm:p-1 sm:px-2 gap-2  sm:border rounded-full sm:rounded-lg sm:w-52 cursor-pointer ${darkAndLightThemeDefault}`} onClick={handleClick}>
                <div className="flex gap-2 items-center">

                    <AvatarBubble dev={user} />

                    <h1 className="hidden sm:flex">{user.name}</h1>
                </div>
                <div className="absolute hidden sm:flex ltr:right-1 rtl:left-1">
                    <MdKeyboardArrowDown />
                </div>
            </button>
            <div className="absolute top-full flex flex-col gap-1 w-52">
                {
                    optionsShow &&
                    <div className="menu m-0 p-0 mt-[1px]">
                        
                        <span className="flex items-center justify-center flex-nowrap rounded-t-md gap-2 pb-[2px] h-12  w-52 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-600">
                            <div className="flex flex-col items-center">

                            <h1 className="sm:hidden">{user.name}</h1>
                            <h1 className="">{user.email}</h1>
                            </div>
                        </span>

                        {/* <button onClick={handleGoToProfile} className="btn btn-sm h-10 bg-white border-none dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-none">{t('Profile')}</button>
                        <button onClick={handleGoToPreferences} className="btn btn-sm h-10 bg-white border-none dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-none">{t('Preferences', {ns: 'settings'})}</button> */}

                        <a href="https://mobile2.global/logout" className="btn btn-error border-none dark:bg-red-800 dark:text-gray-300 dark:hover:bg-red-700 rounded-b-lg rounded-t-none">{t('Logout')}</a>
                    </div>
                }
            </div>
        </div>
    )
}


export const ProfilePicture = () => {
    const { user, setUser } = useContext(AccountContext)
    const { openErrorModal } = useContext(ContentContext)

    const placeholder = !user.avatar || user.avatar.length < 3

    const handleNewPicture = () => {
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/')) {
            loadingActive(true)
            requestChangeProfilePicture({ userId: user.id, pic: file })
                .then((data) => {
                    setUser(data.user)
                    loadingActive(false)
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(error)
                })
        } else {
            //   alert('Please select an image file');
        }
    };

    const handleFileDelete = () => {
        document.getElementById('delete-profile-modal').showModal()
    }

    return (

        <div className={`group/edit avatar ${placeholder && "placeholder"} border-4 max-w-max border-gray-300 dark:border-gray-600 mt-2 rounded-full relative transition-all duration-300`} onClick={handleNewPicture}>
            {
                placeholder ?

                    <div className="w-24 h-24 rounded-full bg-fuchsia-700 flex items-center justify-center text-white text-5xl select-none">

                        {"GM"}

                    </div> :

                    <div className="w-24 rounded-full">
                        <img
                            alt="User Profile Picture"
                            src={setImageUrl(user.avatar)} />
                    </div>
            }
            {
                user.avatar !== "" &&
                <div className="peer">
                    <DeleteProfileModal />
                    <span 
                        className="hover:bg-red-300 hover:scale-110 transition-all duration-300 text-white absolute -right-1 z-40 cursor-pointer -top-3 bg-red-500 rounded-full text-xl p-1.5"
                        onClick={handleFileDelete}
                    >
                        <MdDelete />
                    </span>
                </div>
            }
            <label className="absolute opacity-0 group-hover/edit:opacity-100 w-24 h-24 rounded-full cursor-pointer peer-hover:opacity-0 flex items-center justify-center text-white bg-gray-500/75 select-none z-10 transition-all duration-300">
                <span className="w-full h-full flex items-center justify-center">
                    <CiEdit size={35} />
                    <input
                        type="file"
                        accept="image/*"
                        className="hidden cursor-pointer"
                        onChange={handleFileChange}
                    />
                </span>
            </label>
        </div>
    )
}


const DeleteProfileModal = () => {
    const { t } = useTranslation('settings')
    const { user, setUser } = useContext(AccountContext)
    const { openErrorModal } = useContext(ContentContext)

    const onClose = () => {
        document.getElementById('delete-profile-modal').close()
    }

    const onSubmit = () => {
        requestDeleteProfilePicture({ userId: user.id })
            .then((data) => {
                setUser(data.user)
                onClose()
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
    }

    return (
        <dialog id="delete-profile-modal" className="modal">
            <form method="dialog" className="modal-box">
                <h3 className="font-bold text-lg">{t('Delete Profile Picture')}</h3>
                <p className="py-4">{t('Are you sure you want to delete your profile picture?')}</p>
                <div className="modal-action">
                    <button className="btn btn-sm" onClick={onClose}>{t('Cancel')}</button>
                    <button className="btn btn-sm btn-error" onClick={onSubmit}>{t('Delete')}</button>
                </div>
            </form>
            <div className="modal-backdrop" onClick={onClose}></div>
        </dialog>
    )
}